package com.appsyde.shared.modules.ai.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AiExtractV2(
    val intent: String? = null,
    val complexity: String? = null,
    val priority: String? = null,

    @SerialName("suggested_action")
    val suggestedAction: SuggestedAction? = null,

    val detected: List<DetectedFieldV2> = emptyList(),
    val missing: List<MissingFieldV2> = emptyList(),

    @SerialName("to_confirm")
    val toConfirm: List<ToConfirmFieldV2> = emptyList(),

    @SerialName("ticket_state_summary")
    val ticketStateSummary: String? = null,

    @SerialName("respond_context")
    val respondContext: String? = null,

    val response: String? = null
)

@Serializable
data class SuggestedAction(
    val code: String? = null,
    val label: String? = null,
    val why: String? = null
)
